import { render, staticRenderFns } from "./UploadProof.vue?vue&type=template&id=81f20352&scoped=true"
import script from "./UploadProof.vue?vue&type=script&lang=js"
export * from "./UploadProof.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81f20352",
  null
  
)

export default component.exports